import qs from 'qs'
import axios from '../config/axios.js'
let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } };
let configV1 = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } };
const BASE_URL = '/api/college_manage'
export const packgeServer = {
  questions: (params) => {
    return axios.get(`${BASE_URL}/question/coursePacks/query`, {params: params}).then(res => res.data)
  },
  questionSort: (params) => {
    return axios.post(`${BASE_URL}/question/coursePacks/uptQuestionSort`, params, configV1).then(res => res.data)
  },
  vedios: (params) => {
    return axios.get(`${BASE_URL}/vedioResource/coursePacks/query`, {params: params}).then(res => res.data)
  },
  vedioSort: (params) => {
    return axios.post(`${BASE_URL}/vedioResource/coursePacks/uptSort`, params, configV1).then(res => res.data)
  },
  coursewares: (params) => {
    return axios.get(`${BASE_URL}/coursewareResource/coursePacks/query`, {params: params}).then(res => res.data)
  },
  coursewareSort: (params) => {
    return axios.post(`${BASE_URL}/coursewareResource/coursePacks/uptSort`, params, configV1).then(res => res.data)
  },
  cases: (params) => {
    return axios.get(`${BASE_URL}/study/coursePacks/query`, {params: params}).then(res => res.data)
  },
  caseSort: (params) => {
    return axios.post(`${BASE_URL}/study/coursePacks/uptSort`, params, configV1).then(res => res.data)
  },
}



// WEBPACK FOOTER //
// ./src/api/server/coursePackage.js